import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Button, Row, Col, Dropdown, Space, Divider, Input, Radio, Select, Form, Image } from "antd";
// import type { MenuProps } from "antd";
import {
  CloseCircleOutlined,
  MinusCircleOutlined,
  PlusCircleOutlined,
  EditOutlined,
  AimOutlined,
  PlusOutlined,
  SaveOutlined,
  CheckOutlined,
  CameraOutlined,
} from "@ant-design/icons";
import { v4 as uuidv4 } from "uuid";
import { allMaterialsList } from "../../constants/materials";
import "./BundleShipmentForm.css";
import MetalForm from "../MetalForm/MetalForm";
const { TextArea } = Input;

export interface BundleShipmentFormProps {
  showForm: boolean;
  metals: any[];
  closeForm: () => void;
  addToMaterialsList: (materialInfo: any) => void;
  editMaterialData: any;
  resetEditMaterialData: () => void;
  getBundles: () => any;
  addBundlesToShipment: (bundleIDs: String[]) => void;
}

const BundleShipmentForm = (props: BundleShipmentFormProps) => {
  const [selectedBundlesFormStatus, setSelectedBundlesFormStatus] = useState("") as any;
  const [selectedBundlesFormMessage, setSelectedBundlesFormMessage] = useState("");
  const [bundlesList, setBundlesList] = useState([]) as any;
  const [selectedBundles, setSelectedBundles] = useState([]) as any;

  useEffect(() => {
    getBundlesList();
  }, [props.editMaterialData, props.metals]);

  const getBundlesList = async () => {
    const bundles = await props.getBundles();
    const updatedBundlesList = bundles.map((bundle: any) => {
      const currMetal: any = props.metals.find((metal: any) => metal.metalID === bundle.metalID);
      bundle.key = bundle.materialID;
      bundle.displayName = currMetal ? currMetal.displayName : "";
      return {
        label: `${bundle.displayName} (${bundle.netWeight} kg) `,
        value: bundle.materialID,
        ...bundle,
      };
    });
    setBundlesList(updatedBundlesList);
  };

  const updateSelectedBundles = (bundles: string[]) => {
    setSelectedBundles(bundles);
  };

  const closeForm = () => {
    setSelectedBundles([]);
    setSelectedBundlesFormStatus("");
    setSelectedBundlesFormMessage("");
    props.closeForm();
  };

  const validateForm = () => {
    let validationFormStatus = true;
    if (selectedBundles.length === 0) {
      validationFormStatus = false;
      setSelectedBundlesFormStatus("error");
      setSelectedBundlesFormMessage("Select at least 1 Bundle");
    }
    return validationFormStatus;
  };

  const addBundlesToShipment = () => {
    props.addBundlesToShipment(selectedBundles);
    setSelectedBundles([]);
    setSelectedBundlesFormStatus("");
    setSelectedBundlesFormMessage("");
  };

  return props.showForm ? (
    <Row justify="center">
      <div className="material-form">
        <Row>
          <Col span={20}>
            <Row justify="start">Add Completed Bundle</Row>
          </Col>
          <Col span={4}>
            <Row justify="end">
              <CloseCircleOutlined onClick={() => closeForm()} />
            </Row>
          </Col>
        </Row>
        <Row>
          <Divider style={{ margin: "12px 0" }} />
        </Row>
        <Form layout="vertical">
          <Row className="material-dropdown-container">
            <Col span={24}>
              <Form.Item
                label={<label className="material-form-label">Bundle Name*</label>}
                validateStatus={selectedBundlesFormStatus}
                help={selectedBundlesFormMessage}
              >
                <Select
                  mode="multiple"
                  allowClear
                  style={{ width: "100%" }}
                  placeholder="Select a Bundle"
                  showSearch
                  onChange={updateSelectedBundles}
                  onSearch={() => {}}
                  options={bundlesList}
                  filterOption={(input: any, option: any) => {
                    return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                  }}
                />
              </Form.Item>
              <h4>Selected Bundles:</h4>
              {selectedBundles.map((materialID: any) => {
                const currBundle = bundlesList.find((bundle: any) => bundle.materialID === materialID);
                return (
                  <>
                    <Row align="middle" style={{ minHeight: "50px" }}>
                      <Col span={4}>
                        {currBundle.imageURL ? (
                          <Image
                            height={50}
                            width={50}
                            src={currBundle.imageURL}
                            preview={{
                              toolbarRender: () => (
                                <>
                                  <h1 style={{ color: "#FFFFFF" }}>{currBundle.displayName}</h1>
                                  <h3 style={{ color: "#FFFFFF" }}>
                                    Raw Weight: {Number(currBundle.rawWeight).toFixed(1)} kg
                                  </h3>
                                  <h3 style={{ color: "#FFFFFF" }}>
                                    Net Weight: {Number(currBundle.netWeight).toFixed(1)} kg
                                  </h3>
                                </>
                              ),
                            }}
                          />
                        ) : null}
                      </Col>
                      <Col span={6}>{currBundle.displayName}</Col>
                      <Col span={4}>{currBundle.netWeight}</Col>
                      <Col span={8}>
                        {new Date(currBundle.createdTimestamp).toLocaleDateString("en-GB")}{" "}
                        {new Date(currBundle.createdTimestamp).toLocaleTimeString("en-US", {
                          hour: "numeric",
                          minute: "numeric",
                          hour12: true,
                        })}
                      </Col>
                    </Row>
                    <Divider />
                  </>
                );
              })}
            </Col>
          </Row>
        </Form>
        <Row justify="center" style={{ marginTop: "20px" }}>
          <Button className="cancel-button" onClick={() => closeForm()}>
            Cancel
          </Button>
          <Button type="primary" icon={<CheckOutlined />} onClick={() => validateForm() && addBundlesToShipment()}>
            Add Bundle to Shipment
          </Button>
        </Row>
      </div>
      <div className="overlay"></div>
    </Row>
  ) : null;
};

export default BundleShipmentForm;
